import React, { useState, useEffect, useRef, useContext } from "react";
import { Avatar } from "antd";
import { mainSchema, NAME_SERVER } from "../../../../Utils/NAME_HOST";
import styles from "./Chat.module.css";
import { Context } from "../../../..";
import { observer } from "mobx-react-lite";
import { pack, unpack } from "../../../../Utils/forSocket";
import EmojiPicker from 'emoji-picker-react';
import ToolsAround from "../../../UI/ToolsAround/ToolsAround";

function Chat() {
    const { store } = useContext(Context)
    const [messages, setMessages] = useState([

    ]);
    const [count_messages,setCount_messages] = useState(0)
    const [statusToolUp, setStatusToolUp] = useState(false)


    const [showEmojiPicker, setShowEmojiPicker] = useState(false);

    const [inputValue, setInputValue] = useState("");
    const messagesEndRef = useRef(null); // Реф для элемента, в который прокручиваем
    function scrollBottom() {
        const container = messagesEndRef.current;
        if (container) {
            container.scrollTop = container.scrollHeight;
            setStatusToolUp(false)
            
        }
    }
    const handleScroll = () => {
        const container = messagesEndRef.current;
        if (container) {
            const result = container.scrollHeight - container.scrollTop > container.clientHeight+200
            
            setStatusToolUp((prev)=>{
                if (prev !== result){
                    return result===true?true:false
                }
                return prev
            })
            
            // Показываем кнопку, если прокрутка находится не внизу
            
        }
    };
    const handleSend = (e) => {

        if (inputValue.trim()) {
            e.preventDefault(); // Предотвращает перенос строки в textarea


            store.socket.send(pack({ event: "send_message", data: { message: inputValue } }));


            setInputValue("");
        }
    };
    async function listenSocket() {
        const socket = store.socket;


        socket.addEventListener('message', async (eventClient) => {
            const dataClient = mainSchema.decode(eventClient.data)

            // const dataClient = this.unpack(eventClient.data);
            const event = dataClient.event;
            let data = dataClient.data;
            if (dataClient.event.length > 1) {
                data = unpack(data);
            }
            if (event === "messages") {
                setMessages(data);
            }
            
            if (event === "new_message") {
                
                setCount_messages(prevCount=>prevCount+1)
                

                setMessages((prevMessages) => [...prevMessages, data]);


            }

        })
    }
    
    useEffect(()=>{
        if (!statusToolUp){
            setCount_messages(0)
        }
    },[statusToolUp,count_messages])
    // Автопрокрутка вниз после добавления нового сообщения
    useEffect(() => {
        if (!statusToolUp){
            setTimeout(() => {
                scrollBottom()
            }, 100)
        }
        
    }, [messages])
    useEffect(()=>{
        if (store.state_socket === "open"){
            listenSocket()

            store.socket.send(pack({ event: "get_messages", data: {} }));

        }
    },[store.state_socket])

    // Прокрутка вниз при первичной загрузке
    useEffect(() => {
        const container = messagesEndRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            // Очистка обработчика при размонтировании компонента
            return () => container.removeEventListener('scroll', handleScroll);
        }


    }, []);
    const onEmojiClick = (emojiData, event) => {
        setInputValue(prevInput => prevInput + emojiData.emoji);
        setShowEmojiPicker(false); // Закрываем выбор смайликов после выбора
    };
    const handleInput = (e) => {
        setInputValue(e.target.value);

    };

    return (
        <>
            {statusToolUp && (
                <div className={styles.containerTool}>
                    <ToolsAround style={{ width: "40px", height: "40px" }} onClick={scrollBottom} element={
                        <>
                            {count_messages>0&&<div className={styles.blockNotifMessage}>{count_messages}</div>}
                            
                            <i style={{ fontSize: "20px" }} className="fa-solid fa-arrow-down"></i>
                        </>
                    } />
                </div>
            )}
            <div className={styles.texts} ref={messagesEndRef}>
                {messages.map((message, index) => (
                    <div key={index} className={styles.blockUser}>
                        <div>
                            {message.admin ? (
                                <Avatar size={55} style={{ backgroundColor: "#ff000085" }}>
                                    <img src={NAME_SERVER + "/assets/avatars/2.gif"} alt="avatar" />
                                </Avatar>
                            ) : (
                                <Avatar size={55} style={{ backgroundColor: message.colorAvatar }}>
                                    <img src={message.avatar} alt="avatar" />
                                </Avatar>
                            )}

                        </div>
                        <div className={styles.info}>
                            <div className={styles.head}>
                                {message.admin ? (
                                    <div style={{ color: "red" }}>{store.dataLang["admin_name"]}</div>

                                ) : (
                                    <div style={{ color: message.nickname === store.user.login ? "gold" : "" }}>{message.nickname}</div>

                                )}
                            </div>
                            <div className={styles.text}>

                                <p>{message.admin?store.dataLang[message.text]:message.text}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div >
            <div className={styles.chat_input}>
                <textarea
                    type="text"
                    placeholder={store.dataLang["enter_message"]}
                    value={inputValue}
                    onChange={handleInput}
                    onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && handleSend(e)}
                />
                {!store.isPhone&&
                <button style={{ marginRight: "5px" }} className={styles.send} onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                >
                    <i className="fa-solid fa-smile"></i> {/* Иконка для открытия смайликов */}

                </button>
                }
                

                <button className={styles.send} onClick={handleSend}>
                    <i className="fa-solid fa-paper-plane"></i>
                </button>

                {showEmojiPicker && (
                    <div className={styles.emoji_picker}>

                        <EmojiPicker onEmojiClick={onEmojiClick} />

                    </div>

                )}
            </div>
        </>
    );
}

export default observer(Chat);
